
import { useState } from 'react';
import SEOHead from '../../components/SEOHead';

const ServicesPage = () => {
  const [selectedService, setSelectedService] = useState(0);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hig-construcao-servicos.pt';

  const services = [
    {
      id: 'remodelacao-completa',
      title: 'Remodelação Completa',
      icon: 'ri-home-4-line',
      description: 'Transformação total da sua casa com planeamento completo e execução profissional.',
      features: [
        'Planeamento e design personalizado',
        'Demolições e construção',
        'Instalações elétricas e canalizações',
        'Pavimentos e revestimentos',
        'Pintura e acabamentos',
        'Gestão completa do projeto'
      ],
      image: 'https://public.readdy.ai/ai/img_res/a1e25872f636e4b25e22b5ee5dca7de1.jpg',
      price: 'A partir de €15.000'
    },
    {
      id: 'cozinhas',
      title: 'Renovação de Cozinhas',
      icon: 'ri-restaurant-line',
      description: 'Cozinhas modernas e funcionais adaptadas ao seu estilo de vida e necessidades.',
      features: [
        'Design personalizado',
        'Móveis de cozinha à medida',
        'Eletrodomésticos integrados',
        'Bancadas em pedra natural',
        'Iluminação LED moderna',
        'Otimização do espaço'
      ],
      image: 'https://readdy.ai/api/search-image?query=Bright%20modern%20kitchen%20renovation%20in%20Portuguese%20home%20with%20balanced%20African%20and%20European%20renovation%20team%20partnership.%20Equal%20representation%20of%20African%20heritage%20and%20European%20heritage%20professionals%20collaborating%20to%20install%20white%20cabinets%2C%20granite%20countertops%2C%20stainless%20steel%20appliances%2C%20contemporary%20lighting%20and%20island.%20Professional%20renovation%20work%20showcasing%20quality%20craftsmanship%2C%20teamwork%20and%20functional%20layout.%20Bright%2C%20spacious%20kitchen%20with%20natural%20light%20and%20premium%20finishes%20in%20Braga%20with%20diverse%20skilled%20workers.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=600&height=400&seq=kitchen7&orientation=landscape',
      price: 'A partir de €8.000'
    },
    {
      id: 'casas-banho',
      title: 'Casas de Banho',
      icon: 'ri-drop-line',
      description: 'Casas de banho elegantes e funcionais com materiais de alta qualidade.',
      features: [
        'Design contemporâneo',
        'Cerâmicos de qualidade premium',
        'Louças sanitárias modernas',
        'Chuveiros e banheiras',
        'Móveis de casa de banho',
        'Sistemas de ventilação'
      ],
      image: 'https://readdy.ai/api/search-image?query=Bright%20luxurious%20bathroom%20renovation%20with%20balanced%20African%20and%20European%20professional%20team%20partnership.%20Equal%20representation%20of%20African%20heritage%20and%20European%20heritage%20skilled%20workers%20collaborating%20to%20install%20marble%20tiles%2C%20modern%20fixtures%2C%20glass%20shower%20enclosure%2C%20elegant%20vanity%20and%20contemporary%20lighting.%20Portuguese%20home%20bathroom%20design%20with%20high-end%20finishes%2C%20professional%20teamwork%20and%20sophisticated%20styling.%20Clean%2C%20bright%20space%20with%20premium%20materials%20and%20quality%20craftsmanship%20in%20Braga%20with%20diverse%20professionals.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=600&height=400&seq=bathroom7&orientation=landscape',
      price: 'A partir de €5.000'
    },
    {
      id: 'pintura',
      title: 'Pintura Interior e Exterior',
      icon: 'ri-brush-line',
      description: 'Serviços de pintura profissional para renovar e proteger os seus espaços.',
      features: [
        'Preparação de superfícies',
        'Tintas de alta qualidade',
        'Técnicas especializadas',
        'Proteção de móveis',
        'Acabamentos perfeitos',
        'Limpeza final incluída'
      ],
      image: 'https://readdy.ai/api/search-image?query=Bright%20professional%20painting%20service%20in%20Portuguese%20home%20with%20balanced%20African%20and%20European%20team%20partnership.%20Equal%20representation%20of%20African%20heritage%20and%20European%20heritage%20skilled%20painters%20working%20together%20painting%20fresh%20walls%20in%20modern%20colors.%20Clean%2C%20bright%20interior%20with%20quality%20paint%20finish%2C%20protected%20furniture%20and%20professional%20painting%20equipment.%20Diverse%20painters%20collaborating%20with%20attention%20to%20detail%20and%20quality%20craftsmanship%20in%20Braga%20renovation%20project%20with%20balanced%20team%20representation.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=600&height=400&seq=painting6&orientation=landscape',
      price: 'A partir de €2.000'
    },
    {
      id: 'carpintaria',
      title: 'Carpintaria',
      icon: 'ri-hammer-line',
      description: 'Trabalhos de carpintaria personalizados e móveis à medida para a sua casa.',
      features: [
        'Móveis à medida',
        'Armários embutidos',
        'Estantes e prateleiras',
        'Portas e janelas',
        'Deck e pergolas',
        'Reparações em madeira'
      ],
      image: 'https://readdy.ai/api/search-image?query=Bright%20custom%20carpentry%20work%20in%20Portuguese%20home%20with%20balanced%20African%20and%20European%20skilled%20carpenters%20partnership.%20Equal%20representation%20of%20African%20heritage%20and%20European%20heritage%20professionals%20collaborating%20to%20build%20built-in%20wardrobes%2C%20wooden%20shelving%20and%20furniture.%20Professional%20woodworking%20with%20quality%20materials%2C%20precise%20craftsmanship%2C%20teamwork%20and%20modern%20design.%20Clean%20workshop%20environment%20with%20diverse%20skilled%20carpenters%20working%20together%20on%20bespoke%20furniture%20project%20in%20Braga%20with%20balanced%20representation.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=600&height=400&seq=carpentry6&orientation=landscape',
      price: 'A partir de €1.500'
    },
    {
      id: 'reparacoes',
      title: 'Reparações Gerais',
      icon: 'ri-tools-line',
      description: 'Pequenas e grandes reparações para manter a sua casa em perfeito estado.',
      features: [
        'Reparações elétricas',
        'Problemas de canalização',
        'Fissuras e humidade',
        'Substituição de azulejos',
        'Reparação de portas',
        'Manutenção preventiva'
      ],
      image: 'https://readdy.ai/api/search-image?query=Bright%20general%20home%20repairs%20and%20maintenance%20work%20in%20Portuguese%20house%20with%20balanced%20African%20and%20European%20professional%20team%20partnership.%20Equal%20representation%20of%20African%20heritage%20and%20European%20heritage%20skilled%20handymen%20collaborating%20to%20fix%20electrical%20issues%2C%20plumbing%20repairs%20and%20wall%20maintenance.%20Quality%20tools%20and%20equipment%20showing%20skilled%20repair%20work%2C%20teamwork%20and%20attention%20to%20detail.%20Clean%2C%20organized%20workspace%20demonstrating%20professional%20repair%20services%20with%20diverse%20team%20partnership%20in%20Braga%20with%20balanced%20representation.%20Well-lit%20environment%20with%20abundant%20natural%20light%20and%20minimal%20shadows.&width=600&height=400&seq=repairs6&orientation=landscape',
      price: 'A partir de €200'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Contacto Inicial',
      description: 'Entre em contacto connosco para discutir o seu projeto e necessidades.'
    },
    {
      step: '02',
      title: 'Visita e Avaliação',
      description: 'Visitamos o local para avaliar o trabalho e compreender os seus objetivos.'
    },
    {
      step: '03',
      title: 'Orçamento Detalhado',
      description: 'Apresentamos um orçamento detalhado com prazos e especificações.'
    },
    {
      step: '04',
      title: 'Execução do Projeto',
      description: 'Iniciamos os trabalhos com qualidade e cumprimento de prazos.'
    },
    {
      step: '05',
      title: 'Entrega Final',
      description: 'Entregamos o projeto concluído com garantia de qualidade.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Serviços de Remodelação - HIG Construção Braga Portugal"
        description="Serviços completos de remodelação em Braga: renovação de cozinhas, casas de banho, pintura, carpintaria e reparações gerais. Orçamentos gratuitos e qualidade garantida."
        keywords="serviços remodelação Braga, renovação cozinhas, casas banho, pintura, carpintaria, reparações"
        canonical={`${siteUrl}/servicos`}
        pageType="Service"
      />

      {/* Navigation */}
      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
                HIG Construção e Serviços
              </a>
            </div>
            
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <a href="/" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Início</a>
                <a href="/servicos" className="text-gray-900 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Serviços</a>
                <a href="/#projetos" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Projetos</a>
                <a href="/#sobre" className="text-gray-700 hover:text-teal-600 px-3 py-2 text-sm font-medium cursor-pointer">Sobre</a>
                <a href="/#contacto" className="bg-teal-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-teal-700 cursor-pointer whitespace-nowrap">Contacto</a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-teal-600 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Os Nossos Serviços
          </h1>
          <p className="text-xl text-teal-100 max-w-3xl mx-auto">
            Oferecemos uma gama completa de serviços de remodelação para transformar 
            a sua casa no espaço dos seus sonhos em Braga e arredores.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Service List */}
            <div className="lg:col-span-1">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Escolha o Serviço</h3>
              <div className="space-y-4">
                {services.map((service, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedService(index)}
                    className={`w-full text-left p-4 rounded-lg border-2 transition-all ${
                      selectedService === index
                        ? 'border-teal-600 bg-teal-50'
                        : 'border-gray-200 hover:border-teal-300'
                    }`}
                  >
                    <div className="flex items-center">
                      <div className={`w-12 h-12 rounded-lg flex items-center justify-center mr-4 ${
                        selectedService === index ? 'bg-teal-600' : 'bg-gray-100'
                      }`}>
                        <i className={`${service.icon} text-xl ${
                          selectedService === index ? 'text-white' : 'text-gray-600'
                        }`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-gray-900">{service.title}</h4>
                        <p className="text-sm text-gray-600">{service.price}</p>
                      </div>
                    </div>
                  </button>
                ))}
              </div>
            </div>

            {/* Service Details */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                <img 
                  src={services[selectedService].image}
                  alt={services[selectedService].title}
                  className="w-full h-64 object-cover object-top"
                />
                <div className="p-8">
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">
                    <strong>{services[selectedService].title}</strong>
                  </h3>
                  <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                    {services[selectedService].description}
                  </p>
                  
                  <div className="mb-6">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">O que inclui:</h4>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {services[selectedService].features.map((feature, index) => (
                        <li key={index} className="flex items-center text-gray-600">
                          <i className="ri-check-line text-teal-600 mr-3"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="flex items-center justify-between">
                    <div className="text-2xl font-bold text-teal-600">
                      {services[selectedService].price}
                    </div>
                    <a 
                      href="/#contacto"
                      className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      Pedir Orçamento
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Como Trabalhamos
            </h3>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              O nosso processo é simples e transparente, garantindo que o seu projeto 
              seja executado com qualidade e dentro dos prazos estabelecidos.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
            {process.map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-teal-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                  {step.step}
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">
                  <strong>{step.title}</strong>
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Pronto para Começar o Seu Projeto?
          </h3>
          <p className="text-xl text-teal-100 mb-8 max-w-3xl mx-auto">
            Entre em contacto connosco hoje mesmo para um orçamento gratuito 
            e sem compromisso. Estamos prontos para transformar a sua casa!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/#contacto"
              className="bg-white text-teal-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              Pedir Orçamento Gratuito
            </a>
            <a 
              href="https://wa.me/351936602153"
              target="_blank"
              rel="noopener noreferrer"
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-teal-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center"
            >
              <i className="fab fa-whatsapp mr-2"></i>
              Contactar WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/351936602153"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
        aria-label="Contactar via WhatsApp"
      >
        <i className="fab fa-whatsapp text-2xl"></i>
      </a>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h5 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
                HIG Construção e Serviços
              </h5>
              <p className="text-gray-400 leading-relaxed">
                Especialistas em remodelações de casas em Braga. 
                Qualidade, rapidez e preços competitivos.
              </p>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Serviços</h6>
              <ul className="space-y-2 text-gray-400">
                <li><a href="#" className="hover:text-white cursor-pointer">Remodelação Completa</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Renovação Cozinhas</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Casas de Banho</a></li>
                <li><a href="#" className="hover:text-white cursor-pointer">Pintura</a></li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Contacto</h6>
              <ul className="space-y-2 text-gray-400">
                <li>Avenida Dom Pedro Nunes 587</li>
                <li>Vila Verde, Braga</li>
                <li>936 602 153 | 193 931 073</li>
                <li>hanielany@gmail.com</li>
              </ul>
            </div>
            
            <div>
              <h6 className="font-semibold mb-4">Siga-nos</h6>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-600 transition-colors cursor-pointer">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="https://wa.me/351936602153" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer">
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 HIG Construção e Serviços. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white ml-2" rel="nofollow">Web Design</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ServicesPage;
